module.exports = __webpack_public_path__ + "media/images/metronic/social/gravatar-8d919b49005b4550c17e2fadfa6b17bb.png";